import { render, staticRenderFns } from "./importTeacher.vue?vue&type=template&id=da25ee0e&"
import script from "./importTeacher.vue?vue&type=script&lang=js&"
export * from "./importTeacher.vue?vue&type=script&lang=js&"
import style0 from "./importTeacher.vue?vue&type=style&index=0&id=da25ee0e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports